import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'sideorder',
  entityPlural: 'sideorders',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: true
  }
});
